import { Fragment, useEffect, useState } from "react";
import { Dialog, Popover, Tab, Transition } from "@headlessui/react";
import {
  Bars3Icon,
  MagnifyingGlassIcon,
  ShoppingBagIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { Avatar, Button, Menu, MenuItem } from "@mui/material";
import { navigation } from "../../../config/navigationMenu";
import AuthModal from "../Auth/AuthModal";
import { useDispatch, useSelector } from "react-redux";
import { deepPurple } from "@mui/material/colors";
import { getUser, logout } from "../../../Redux/Auth/Action";
import { getCart } from "../../../Redux/Customers/Cart/Action";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Logo from "../../../Assets/ashapura_logo.png";
import "./Navigation.css";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Navigation() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { auth, cart } = useSelector((store) => store);
  const [openAuthModal, setOpenAuthModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorCatEl, setAnchorCatEl] = useState(null);
  const [cartCount, setCartCount] = useState(0);
  const openUserMenu = Boolean(anchorEl);
  const jwt = localStorage.getItem("jwt");
  const location = useLocation();

  useEffect(() => {
    if (jwt) {
      dispatch(getUser(jwt));
      dispatch(getCart(jwt));
    }
  }, [jwt]);

  useEffect(() => {
    dispatch(getCart(jwt));
  }, []);

  useEffect(() => {
    if (cart) {
      setCartCount(cart?.cartItems?.length);
    }
  }, [cart]);

  const handleUserClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseUserMenu = (event) => {
    setAnchorEl(null);
  };

  const handleOpen = () => {
    setOpenAuthModal(true);
  };
  const handleClose = () => {
    setOpenAuthModal(false);
  };

  const handleCategoryClick = (category, section, item, close) => {
    let url = `/${category.id}/${section.id}/${item.id}`;
    if (item.viewAll) {
      url = `${url}?view_all=true`;
    } else {
      url = `${url}?view_all=false`;
    }
    navigate(url);
    close();
  };

  useEffect(() => {
    if (auth.user) {
      handleClose();
    }
    if (
      auth.user?.role !== "ADMIN" &&
      (location.pathname === "/login" || location.pathname === "/register")
    ) {
      navigate(-1);
    }
  }, [auth.user]);

  const handleLogout = () => {
    handleCloseUserMenu();
    dispatch(logout());
    setOpen(false);
    navigate("/");
  };
  const handleMyOrderClick = () => {
    handleCloseUserMenu();
    setOpen(false);
    navigate("/account/order");
  };

  const handleMyProfileClick = () => {
    handleCloseUserMenu();
    setOpen(false);
    navigate("/account/profile");
  };

  const handlePopoverOpen = (event) => {
    setAnchorCatEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorCatEl(null);
  };

  const openCat = Boolean(anchorEl);

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  return (
    <div className="bg-[#F8ECD7] shadow-lg">
      {/* Mobile menu */}
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-40 lg:hidden" onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 z-40 flex">
            <Transition.Child
              as={Fragment}
              enter="transition ease-in-out duration-300 transform"
              enterFrom="-translate-x-full"
              enterTo="translate-x-0"
              leave="transition ease-in-out duration-300 transform"
              leaveFrom="translate-x-0"
              leaveTo="-translate-x-full"
            >
              <Dialog.Panel className="relative flex w-full max-w-xs flex-col overflow-y-auto bg-[#FFFBF2] shadow-md">
                <div className="flex px-4 pb-2 pt-5 justify-between border-b">
                  <div className="space-y-6 text-gray-400">
                    <div className="flow-root">
                      {/* <a
                      href="/"
                      className="-m-2 block p-2 font-medium text-gray-900"
                    > */}
                      {auth.user ? (
                        <p>
                          <span className="text-[#f00]">Hello!</span>{" "}
                          {auth.user?.firstName}
                        </p>
                      ) : (
                        <div
                          onClick={handleOpen}
                          className="-m-2 block p-2 font-medium text-[#511D00] cursor-pointer"
                        >
                          Sign in
                        </div>
                      )}
                      {/* </a> */}
                    </div>
                  </div>
                  <button
                    type="button"
                    className="-m-2 inline-flex items-center justify-center p-2 text-gray-400"
                    onClick={() => setOpen(false)}
                  >
                    <span className="sr-only">Close menu</span>
                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </div>
                <div className="lg:hidden bg-[#FFFBF2] z-30 mt-5">
                  {navigation.categories.map((category) => (
                    <Accordion
                      sx={{
                        backgroundColor: "#FFFBF2",
                        border: "none",
                        boxShadow: "none",
                        margin: 0,
                        padding: 0,
                      }}
                    >
                      <AccordionSummary
                        expandIcon={<ArrowDropDownIcon />}
                        aria-controls="panel2-content"
                        id="panel2-header"
                      >
                        <Typography>{category.name}</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        {category.sections.length > 1 ? (
                          <>
                            {category.sections.map((section) => (
                              <Accordion
                                sx={{
                                  backgroundColor: "#FFFBF2",
                                  border: "none",
                                  boxShadow: "none",
                                  margin: 0,
                                  padding: 0,
                                }}
                              >
                                <AccordionSummary
                                  expandIcon={<ArrowDropDownIcon />}
                                  aria-controls="panel2-content"
                                  id={`panel1-header-${section.id}`}
                                >
                                  <Typography>{section.name}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                  <ul
                                    role="list"
                                    aria-labelledby={`${category.id}-${section.id}-heading-mobile`}
                                    className="flex flex-col gap-0"
                                  >
                                    {section.items.map((item) => (
                                      <li
                                        key={item.name}
                                        className="flow-root mb-4"
                                      >
                                        <p
                                          // className="block text-gray-500"
                                          onClick={() => {
                                            handleCategoryClick(
                                              category,
                                              section,
                                              item,
                                              () => ({})
                                            );
                                            setOpen(false);
                                          }}
                                          className="cursor-pointer hover:text-gray-800"
                                        >
                                          {item.name}
                                        </p>
                                      </li>
                                    ))}
                                  </ul>
                                </AccordionDetails>
                              </Accordion>
                            ))}
                          </>
                        ) : (
                          <ul
                            role="list"
                            aria-labelledby={`${category.id}-${category.sections.id}-heading-mobile`}
                            className="flex flex-col space-y-2"
                          >
                            {category.sections[0].items.map((item) => (
                              <li key={item.name} className="">
                                <p
                                  onClick={() => {
                                    handleCategoryClick(
                                      category,
                                      category.sections[0],
                                      item,
                                      () => ({})
                                    );
                                    setOpen(false);
                                  }}
                                  className="mb-2 cursor-pointer hover:text-gray-00"
                                >
                                  {item.name}
                                </p>
                              </li>
                            ))}
                          </ul>
                        )}
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </div>
                {auth.user && (
                  <>
                    <div
                      className="space-y-6 px-4 pt-3 pb-3 border-t"
                      onClick={handleMyProfileClick}
                    >
                      <p>My Profile</p>
                    </div>
                    <div
                      className="space-y-6 px-4 pt-3 pb-3 border-t"
                      onClick={handleMyOrderClick}
                    >
                      <p>My Orders</p>
                    </div>

                    <div
                      className="space-y-6 px-4 pt-3 border-t text-[#f00] font-medium"
                      onClick={handleLogout}
                    >
                      <p>Sign Out</p>
                    </div>
                  </>
                )}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>

      <header className="text-white bg-[#F8ECD7] sticky top-0 z-10">
        <div id="scroll-container">
          <p
            id="scroll-text"
            className="flex h-10 items-center justify-center px-4 text-sm font-medium text-white sm:px-6 lg:px-8 uppercase font-bold font-mono marquee 25s linear infinite animate-marquee2"
          >
            {/* Get free delivery on orders over &#8377;1000 |  */}
            Tailored Solutions for Bulk and Custom Orders – Get in Touch at +91
            9784254025
          </p>
        </div>

        <nav
          // aria-label="Top"
          className="bg-[#F8ECD7]"
        >
          <div className="">
            <div className="flex h-16 items-center justify-between lg:px-11">
              <button
                type="button"
                className="rounded-md p-2 text-gray-400 lg:hidden"
                onClick={() => setOpen(true)}
              >
                <span className="sr-only">Open menu</span>
                <Bars3Icon className="h-6 w-6" aria-hidden="true" />
              </button>

              {/* Logo */}
              <div className="flex lg:ml-0">
                <Link to="/">
                  <span className="sr-only">Your Company</span>
                  <img
                    src={Logo}
                    alt="Shopwithzosh"
                    width={100}
                    // height=
                    // className="h-8 w-12"
                  />
                </Link>
              </div>

              {/* Flyout menus */}
              <Popover.Group className="hidden lg:ml-8 lg:block lg:self-stretch z-10">
                <div className="flex h-full space-x-8">
                  {navigation.categories.map((category) => (
                    <Popover
                      key={category.name}
                      className="flex"
                      onMouseEnter={handlePopoverOpen}
                      onMouseLeave={handlePopoverClose}
                      aria-haspopup="true"
                      aria-owns={
                        open ? `mouse-over-${category.name}` : undefined
                      }
                    >
                      {({ open, close }) => (
                        <>
                          <div className="relative flex">
                            <Popover.Button
                              className={classNames(
                                "text-[#511D00] relative z-10 -mb-px flex items-center pt-px text-sm font-medium transition-colors duration-200 ease-out"
                              )}
                            >
                              {category.name}
                            </Popover.Button>
                          </div>

                          <Transition
                            as={Fragment}
                            enter="transition ease-out duration-200"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="transition ease-in duration-150"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                          >
                            <Popover.Panel
                              className="absolute top-full text-sm text-gray-500 bg-[#F8ECD7]"
                              id={`mouse-over-${category.name}`}
                              sx={{ pointerEvents: "none" }}
                              open={openCat}
                              anchorEl={anchorCatEl}
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                              }}
                              transformOrigin={{
                                vertical: "top",
                                horizontal: "left",
                              }}
                              onClose={handlePopoverClose}
                              disableRestoreFocus
                            >
                              {/* Presentational element used to render the bottom shadow, if we put the shadow on the actual panel it pokes out the top, so we use this shorter element to hide the top of the shadow */}
                              <div
                                className="absolute top-1/2 bg-[#F8ECD7] shadow"
                                aria-hidden="true"
                              />
                              <div className="relative bg-[#F8ECD7]">
                                <div className="mx-auto max-w-7xl px-8">
                                  <div className="grid grid-cols-1 gap-x-8 gap-y-10 py-5">
                                    <div
                                      className={`row-start-1 grid  ${
                                        category.sections.length > 3
                                          ? "grid-cols-5"
                                          : "grid-cols-1"
                                      } gap-x-8 gap-y-8 text-sm`}
                                    >
                                      {category.sections.map((section) => (
                                        <div key={section.name}>
                                          <p
                                            id={`${section.name}-heading`}
                                            className={`font-medium text-gray-900 ${
                                              category.sections.length == 1 &&
                                              "hidden"
                                            }`}
                                          >
                                            {section.name}
                                          </p>

                                          {/* eslint-disable-next-line jsx-a11y/no-redundant-roles */}
                                          <ul
                                            role="list"
                                            aria-labelledby={`${section.name}-heading`}
                                            className="mt-6 space-y-6 sm:mt-4 sm:space-y-4"
                                          >
                                            {section.items.map((item) => (
                                              <li
                                                key={item.name}
                                                className="flex"
                                              >
                                                <p
                                                  onClick={() =>
                                                    handleCategoryClick(
                                                      category,
                                                      section,
                                                      item,
                                                      close
                                                    )
                                                  }
                                                  className="cursor-pointer hover:text-gray-800"
                                                >
                                                  {item.name}
                                                </p>
                                              </li>
                                            ))}
                                          </ul>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Popover.Panel>
                          </Transition>
                        </>
                      )}
                    </Popover>
                  ))}

                  {navigation.pages.map((page) => (
                    <Link
                      to={page.href}
                      className="flex items-center text-sm font-medium text-gray-700 hover:text-gray-800"
                    >
                      {page.name}
                    </Link>
                  ))}
                </div>
              </Popover.Group>

              <div className="lg:ml-auto flex items-center">
                <div className="hidden lg:flex lg:flex-1 lg:items-center lg:justify-end lg:space-x-6">
                  {auth.user && (
                    <div>
                      <Avatar
                        className="text-white"
                        onClick={handleUserClick}
                        aria-controls={open ? "basic-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                        sx={{
                          bgcolor: "#B2A885",
                          color: "white",
                          cursor: "pointer",
                        }}
                      >
                        {auth.user?.firstName[0].toUpperCase()}
                      </Avatar>

                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={openUserMenu}
                        onClose={handleCloseUserMenu}
                        MenuListProps={{
                          "aria-labelledby": "basic-button",
                        }}
                      >
                        <MenuItem onClick={handleMyProfileClick}>
                          My Profile
                        </MenuItem>

                        <MenuItem onClick={handleMyOrderClick}>
                          My Orders
                        </MenuItem>
                        <MenuItem onClick={handleLogout}>SignOut</MenuItem>
                      </Menu>
                    </div>
                  )}

                  {!auth.user && (
                    <Button
                      onClick={handleOpen}
                      className="text-sm font-medium text-[#511D00]"
                      sx={{
                        color: "#511D00",
                        display: `{${auth.user} ? 'block', 'none'}`,
                      }}
                    >
                      Sign in
                    </Button>
                  )}
                </div>

                {/* Search */}
                {/* <div className="flex lg:ml-6">
                  <p className="p-2 text-gray-400 hover:text-gray-500">
                    <span className="sr-only">Search</span>
                    <MagnifyingGlassIcon
                      className="h-6 w-6"
                      aria-hidden="true"
                    />
                  </p>
                </div> */}

                {/* Cart */}
                <div className="lg:flow-root lg:ml-6">
                  <Button
                    onClick={() => navigate("/cart")}
                    className="group -m-2 flex items-center p-2"
                  >
                    <ShoppingBagIcon
                      className="h-6 w-6 lg:flex-shrink-0 text-gray-400 group-hover:text-gray-500"
                      aria-hidden="true"
                    />
                    <span className="ml-2 text-sm font-medium text-gray-700 group-hover:text-gray-800">
                      {cartCount}
                    </span>
                    {/* <span className="sr-only">items in cart, view bag</span> */}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>
      <AuthModal
        handleClose={handleClose}
        open={openAuthModal}
        loginType="login"
      />
    </div>
  );
}
